import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import loaderTheme from '../../styles/loaderTheme';
import loaderKeyframes from '../../styles/loaderKeyframes';
var Dash = styled.span.withConfig({
  displayName: "Dash",
  componentId: "sc-7u097d-0"
})(["animation:", " infinite 1s;background-color:", ";border-radius:", ";height:", ";left:-5%;position:absolute;right:auto;transition:all 1s ease-in-out;width:0.5em;z-index:1;", ""], loaderKeyframes.dashAnimation, function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'loader.dash.backgroundColor', loaderTheme.loader.dash.backgroundColor);
}, rem(2), rem(4), function (_ref2) {
  var skin = _ref2.skin;
  return skin && css(["background-color:currentColor;"]);
});
export default Dash;